module.exports = __webpack_public_path__ + "img/W7022-tran.83ff8a2f.jpg";